import { render, staticRenderFns } from "./proissprior.vue?vue&type=template&id=5927d958&scoped=true&"
import script from "./proissprior.vue?vue&type=script&lang=js&"
export * from "./proissprior.vue?vue&type=script&lang=js&"
import style0 from "./proissprior.vue?vue&type=style&index=0&id=5927d958&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927d958",
  null
  
)

export default component.exports